document.addEventListener("DOMContentLoaded", function () {
  $('#payment').submit(function(e) {
    e.preventDefault();

    $('#message').removeClass('show');
    $('#message').addClass('hidden');

    let fullName = $('input[name=fullname]').val(),
        cardNumber = $('input[name=cardnumber]').val(),
        expirationDate = $('input[name=expirationdate]').val(),
        securityCode = $('input[name=securitycode]').val(),
        submit = true;

    if(submit) {
      $('#payment button').attr("disabled", true);
      $('#payment button').addClass('bg-grey');
      $('#payment button').append("<img class='load-wait' src='" + translations.theme_path + "/assets/img/ajax-loader.svg' style='margin-left: 10px'>");

      $.ajax({
        type: 'POST',
        url: translations.ajaxurl,
        data: {
          action: 'ogone_payment',
          data: $('#payment').serialize(),
          fullName: fullName,
          cardNumber: cardNumber,
          expirationDate: expirationDate,
          securityCode: securityCode
        },
      }).done(function (data) {
        let response = $.parseJSON(data);

        if (response.success) {
          if (response.data.html_answer) {
            $('form#payment').append(response.data.html_answer);
          } else {
            $('form#payment').remove();
            let confirm_url = translations.url_confirmation.slice(0,-1);
            window.location.replace(confirm_url+'?order_id='+vars.order_id);
          }
        } else {
          let message = response.message;
          if (message == 'redirection') {
            window.location.replace('/');
          }
          $('#payment button').removeClass('bg-grey');
          $('#payment button').attr("disabled", false);
          $('form#payment button img.load-wait').remove();
          $('#message').removeClass('hidden');
          $('#message').addClass('show');
          $('#message').addClass('box-error');
          $('#message').html(message);
        }
      });
    }
  });
});
